import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, Briefcase } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { PartnerAssignmentsView } from "@/components/partner-assignments";

export default function BrokerPartners() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Partners</h1>
          <p className="text-muted-foreground mt-2">
            Manage your business partnerships and expert assignments
          </p>
        </div>
        <Users className="h-8 w-8 text-primary" />
      </div>

      <Tabs defaultValue="expert-assignments" className="space-y-4">
        <TabsList>
          <TabsTrigger value="expert-assignments">Expert Assignments</TabsTrigger>
          <TabsTrigger value="network">Partner Network</TabsTrigger>
        </TabsList>

        <TabsContent value="expert-assignments" className="space-y-4">
          <PartnerAssignmentsView />
        </TabsContent>

        <TabsContent value="network" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Briefcase className="w-5 h-5" />
                Partner Network
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Your partner network directory is currently being developed. 
                Check back soon for updates.
              </p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
